import { gql } from "@apollo/client";

// Queries

export const GET_CATALOG_USERS = gql`
  query {
    getCatalogUsers {
      statusCode
      message
      error
      response {
        nombre
        apellido
        email
        usuario_id
        rol_usuario_id
        empresa_id
        empresa
      }
    }
  }
`;

export const GET_CATALOG_CLIENTS = gql`
  query {
    getCatalogClients {
      statusCode
      message
      error
      response {
        cliente_id
        nombre
      }
    }
  }
`;

export const GET_CATALOG_EXPERTS = gql`
  query {
    getCatalogExperts {
      statusCode
      message
      error
      response {
        razon_social
        nombre
        sigla
        rfc
        email
        direccion
        cp
        municipio
        estado
        experto_id
        telefono
      }
    }
  }
`;

export const GET_CATALOG_ADJUSTERS = gql`
  query {
    getCatalogAdjusters {
      statusCode
      message
      error
      response {
        ajustador_id
        nombre
        razon_social
        sigla
        rfc
        email
        direccion
        cp
        municipio
        estado
        telefono
      }
    }
  }
`;

export const GET_CATALOG_BRANCHES = gql`
  query {
    getCatalogBranches {
      statusCode
      message
      error
      response {
        valor
        ramo_id
      }
    }
  }
`;

export const GET_CATALOG_EXCHANGE = gql`
  query {
    getCatalogExchangeTypes {
      statusCode
      message
      error
      response {
        valor
        tipo_cambio_id
      }
    }
  }
`;

// Mutations
export const CREATE_BRANCH = gql`
  mutation createBranch($valor: String) {
    createBranch(valor: $valor) {
      statusCode
      message
      response
    }
  }
`;

export const CREATE_EXCHANGETYPE = gql`
  mutation createExchangeType($valor: String) {
    createExchangeType(valor: $valor) {
      statusCode
      message
      response
    }
  }
`;

export const DELETE_CATALOG = (name, idName) => {
  return gql`
  mutation deleteCatalog($id: Int) {
    ${name}(${idName}: $id) {
      statusCode
      message
    }
  }
`;
};

export const UPDATE_CATALOG = (name, inputName) => {
  return gql`
  mutation updateCatalog($input: ${inputName}) {
    ${name}(input: $input) {
      statusCode
      message
    }
  }
`;
};
// UPDATE
export const UPDATE_CLIENT = gql`
  mutation updateClient($cliente_id: Int, $nombre: String) {
    updateClient(cliente_id: $cliente_id, nombre: $nombre) {
      statusCode
      message
    }
  }
`;

export const UPDATE_BRANCH = gql`
  mutation updateBranch($valor: String, $ramo_id: Int) {
    updateBranch(valor: $valor, ramo_id: $ramo_id) {
      statusCode
      message
    }
  }
`;
/*
experto_id: Int
      nombre: String
      sigla: String
      rfc: String
      telefono: String
      email: String
      direccion: String
      cp: String
      municipio: String
      estado: String
*/

export const UPDATE_EXCHANGETYPE = gql`
  mutation updateExchangeType($valor: String, $tipo_cambio_id: Int) {
    updateExchangeType(valor: $valor, tipo_cambio_id: $tipo_cambio_id) {
      statusCode
      message
    }
  }
`;

//DELETE
export const DELETE_CLIENT = gql`
  mutation deleteClient($cliente_id: Int) {
    deleteClient(cliente_id: $cliente_id) {
      statusCode
      message
    }
  }
`;

// getCatalogUsers: ResponseCatalogUsers
//     getCatalogClients: ResponseCatalogClients
//     getCatalogExperts: ResponseCatalogExperts
//     getCatalogAdjusters: ResponseCatalogAdjusters
//     getCatalogBranches: ResponseCatalogBranches
//     getCatalogExchangeTypes: ResponseCatalogExchange
